import {
    ThemeProvider,
    createTheme,
    CssBaseline,
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Grid,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    LinearProgress,
    Avatar,
    Menu,
    MenuItem,
    useTheme,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
  } from '@mui/icons-material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import FlexBetween from "components/FlexBetween";

import { useGetEmployeesQuery, useGetAllClockingsQuery, useGetAllBreaksQuery, useDeleteEmployeeMutation, useResetEmployeePinMutation, useUpdateEmployeeMutation, useCreateEmployeeMutation } from "../../state/api";

const Experiences = () => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:768px)'); 

    const experiences = [
        { 
          dates: '2023 - Present', 
          role: 'Creative Design Lead', 
          company: 'GIT', 
          description: 'Managed large-scale design projects and collaborations.' 
        },
        { 
          dates: '2021 - 2023', 
          role: 'Creative Design Lead', 
          company: 'JAVA', 
          description: 'Oversaw the creative process and team for product designs.' 
        },
        { 
          dates: '2020 - 2021', 
          role: 'Creative Design Lead', 
          company: 'HOP', 
          description: 'Led the creative design team and managed cross-functional projects.' 
        },
      ];

  return (
    <Box>
        <Paper sx={{ p: 2, borderRadius: '0.75rem' }}>
            <FlexBetween mb={2}>
                <Typography variant="h4">Manage Experience</Typography>
                <Button variant="contained" startIcon={<AddIcon />}>Add New Experience</Button>
            </FlexBetween>
            <TableContainer>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell>Dates</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {experiences.map(exp => (
                    <TableRow key={`${exp.role}-${exp.company}`}>
                        <TableCell>{exp.dates}</TableCell>
                        <TableCell>{exp.role}</TableCell>
                        <TableCell>{exp.company}</TableCell>
                        <TableCell>{exp.description}</TableCell>
                        <TableCell align="right">
                        <IconButton size="small"><EditIcon /></IconButton>
                        <IconButton size="small"><DeleteIcon /></IconButton>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </Box>
    )

}

export default Experiences;

